import { signal } from 'services/SignalsService'

export  function sendSignal(name) {
  signal.dispatch(name, true)
}
